import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

import styled from "styled-components/macro";

import { faUser } from "@fortawesome/pro-solid-svg-icons";
import API from "Signups/API";
import { signupItemStateHooks } from "Signups/SignupView/SignupSheet/Screens/SignupItems/stateHooks";
import { useSignups } from "Signups/state";

import FnrLoadingBricks from "UI/FnrLoadingBricks";

import { User } from "./Styles";

export default function AddHouseholdMemberEntry({
  user,
  signupItemID,
  closePopover,
}) {
  const [state, dispatch] = useSignups();
  const [isLoading, setIsLoading] = useState(false);
  const isDisabled =
    user.isSignedUpForCurrentItem || user.isSignedUpForOtherItem;
  const { getSignupItem } = signupItemStateHooks.useGetSignupItem();

  const handleUserClick = () => {
    if (isDisabled || isLoading) return;

    setIsLoading(true);

    API.signupOtherUserForItem({
      signupListID: state.currentSignupList.ID,
      signupItemID,
      userID: user.userID,
      signedUpViaID: 5,
    })
      .post()
      .then((responseData) => {
        getSignupItem(signupItemID);
        dispatch({
          type: "Other User Signup Updated",
          signupList: responseData.signupList,
          allSignupLists: responseData.allSignupLists,
        });
        closePopover();
      })
      .catch((err) => {
        alert(
          "Oh no! There was a problem adding the user to the signup. Please try again later."
        );
        closePopover();
      });
  };

  return (
    <User
      key={user.userID}
      role="button"
      onClick={handleUserClick}
      isDisabled={isDisabled}
    >
      {isLoading ? (
        <FnrLoadingBricks color="gray" show />
      ) : (
        <>
          <Icon>
            <FontAwesomeIcon icon={faUser} />
          </Icon>
          <Text>
            {user.name}
            {isDisabled ? <Line2>Already signed up</Line2> : null}
          </Text>
        </>
      )}
    </User>
  );
}

const Icon = styled.div``;
const Text = styled.div``;

const Line2 = styled.div`
  font-size: 12px;
  margin-top: -3px;
  opacity: 0.8;
`;
